// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c4d091dd","160":"3931c483","208":"5ff380f9","293":"c31fb067","453":"e8614d39","516":"3a218ec6","519":"0477c8be","917":"566173c0","946":"6603d6af"}[chunkId] + ".chunk.js";
};